import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-5 bg-zinc-200 rounded" }
const _hoisted_2 = { class: "flex flex-col divide-y divide-zinc-300 lg:flex-row lg:divide-y-0" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 p-3 bg-zinc-100 rounded lg:grid-cols-2 lg:gap-12 lg:p-6" }

import { computed, ref } from 'vue';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

import { Chart, ChartData, ChartOptions, registerables } from 'chart.js';
import { BarChart, ExtractComponentData, LineChart } from 'vue-chart-3';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { formatDataType, formatPercent } from '../formatters/valueFormatters';
import { Attribute } from '../types/Attribute';

interface Emits {
  (e: 'update:selected', index: number): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    selected: null,
    tabs: null
  },
  emits: ["update:selected"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:selected', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selected: number,
  tabs: {
    brands: string[],
    values: number[],
    attribute: Attribute
  }[]
}





Chart.register(...registerables);
Chart.register(ChartDataLabels);


const attribute = computed(() => {
  return props.tabs[props.selected].attribute;
});

const chartData = computed<ChartData>(() => ({
  labels: props.tabs[props.selected].brands.slice(0, chartItemsMax.value),
  
  datasets: [
    {
      data: props.tabs[props.selected].values.slice(0, chartItemsMax.value),
      backgroundColor: [
        '#b91c1c',
        '#be123c',
        '#be185d',
        '#a21caf',
        '#7e22ce',
        '#6d28d9',
        '#4338ca',
        '#1d4ed8',
        '#1e40af',
        '#1e3a8a',
        '#1e3a8a',
        '#1e3a8a',
        '#1e3a8a',
      ],
      borderColor: '#52525b',
    },
  ],
}));

const breakpoints = useBreakpoints(breakpointsTailwind);


const greaterMd = breakpoints.greater('md');

const chartItemsMax = computed(() => {
  return greaterMd.value ? 10 : 5;
})

const chartOptions = computed<ChartOptions<'line' | 'bar'>>(() => ({
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      formatter(value) {
        return formatDataType(attribute.value.dataType, value);
      },
      backgroundColor: '#27272a',
      borderRadius: 5,
      color: '#ffffff',
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          const value = context.raw as number || 0;
          
          return formatDataType(attribute.value.dataType, value);
        },
      },
      yAlign: 'bottom',
    },
  },
  elements: {
    point: {
      radius: 6,
      borderWidth: 0,
    },
  },
  scales: {
    y: {
      ticks: {
        callback: function (value: any) {
          return formatDataType(attribute.value.dataType, value);
        },
      },
    },
  },
}));


function changeTab(index) {
  emit('update:selected', index);
}

const lineChartRef = ref<ExtractComponentData<typeof BarChart>>();
const barChartRef = ref<ExtractComponentData<typeof LineChart>>();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["py-2 px-3 text-sm font-bold hover:text-teal-700 cursor-pointer lg:text-base", {'text-zinc-500': index !== __props.selected}]),
          onClick: ($event: any) => (changeTab(index))
        }, _toDisplayString(tab.attribute.title), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(BarChart), {
        ref_key: "barChartRef",
        ref: barChartRef,
        "chart-data": _unref(chartData),
        options: _unref(chartOptions)
      }, null, 8, ["chart-data", "options"]),
      _createVNode(_unref(LineChart), {
        ref_key: "lineChartRef",
        ref: lineChartRef,
        "chart-data": _unref(chartData),
        options: _unref(chartOptions)
      }, null, 8, ["chart-data", "options"])
    ])
  ]))
}
}

})